import { findMode } from "./modes";
import type {
  AssistantPersona,
  ChatMessage,
  Conversation,
  Project,
} from "./types";

export interface PromptLayers {
  system: string;
  mode?: string;
  project?: string;
  assistant?: string;
  conversation?: string;
  message?: string;
  knowledge?: string;
  artifacts?: string;
}

export interface PromptContext {
  system: string;
  conversation: Conversation;
  project?: Project | undefined;
  assistant?: AssistantPersona | undefined;
  message?: ChatMessage | undefined;
  /** Appended when the workspace is allowed to lift blocks into artifacts. */
  artifactPrompt?: string | undefined;
}

function knowledgeSection(
  project: Project | undefined,
  assistant: AssistantPersona | undefined,
): string {
  return [...(project?.knowledge ?? []), ...(assistant?.knowledge ?? [])]
    .map((item) => `## ${item.name}\n${item.text}`)
    .join("\n\n");
}

export function buildPromptLayers(context: PromptContext): PromptLayers {
  const knowledge = knowledgeSection(context.project, context.assistant);
  const mode = findMode(context.conversation.mode);
  return {
    system: context.system,
    ...(mode.prompt ? { mode: mode.prompt } : {}),
    ...(context.artifactPrompt ? { artifacts: context.artifactPrompt } : {}),
    ...(context.project?.prompt ? { project: context.project.prompt } : {}),
    ...(context.assistant?.prompt ? { assistant: context.assistant.prompt } : {}),
    ...(context.conversation.prompt
      ? { conversation: context.conversation.prompt }
      : {}),
    ...(context.message?.instruction ? { message: context.message.instruction } : {}),
    ...(knowledge ? { knowledge } : {}),
  };
}

export function compileSystemPrompt(layers: PromptLayers): string {
  const sections = [
    ["SYSTEM PROMPT GENERALE — priorità massima", layers.system],
    ["MODALITÀ ATTIVA", layers.mode],
    ["CAPACITÀ DELL'AMBIENTE", layers.artifacts],
    ["PROMPT DEL PROGETTO", layers.project],
    ["KNOWLEDGE BASE", layers.knowledge],
    ["PROMPT DELL'ASSISTENTE / PERSONAGGIO", layers.assistant],
    ["PROMPT DELLA CONVERSAZIONE", layers.conversation],
    ["ISTRUZIONI DEL SINGOLO MESSAGGIO", layers.message],
  ] as const;
  return sections
    .flatMap(([title, body]) =>
      body?.trim() ? [`<layer name="${title}">\n${body.trim()}\n</layer>`] : [],
    )
    .join("\n\n");
}

export function visibleBranch(
  messages: ChatMessage[],
  branchId: string,
): ChatMessage[] {
  return messages.filter((message) => message.branchId === branchId);
}
